/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { combineReducers } from 'redux';

import { makeAsyncSelectors } from '../utils/async_utils';
import availability, { selectors as availabilitySelectors } from './availability';
// import reservation, { selectors as reservationSelectors } from './reservation';
import permit, { selectors as permitSelectors } from './permit';
import permitTypes, { selectors as permitTypesSelectors } from './permitTypes';
import seasons, { selectors as seasonsSelector } from './seasons';
import locations, { selectors as locationsSelector } from './locations';
import reservation, { selectors as reservationSelectors } from './reservation';
import fakeCart from './fakeCartReducer';

// Generate the async selectors
const { isLoaded, isLoading, hasErrors, getErrors } = makeAsyncSelectors('treePermit');

// All of our Redux selectors
// export { getErrors, hasErrors, isLoaded, isLoading, availabilitySelectors, permitSelectors, reservationSelectors };
export {
    getErrors,
    hasErrors,
    isLoaded,
    isLoading,
    permitSelectors,
    locationsSelector,
    seasonsSelector,
    permitTypesSelectors,
    availabilitySelectors,
    reservationSelectors,
};

const reducers = combineReducers({
    permit,
    permitTypes,
    availability,
    locations,
    reservation,
    seasons,
    fakeCart,
});

export default reducers;
